module.exports = __webpack_public_path__ + "roboto-thin-webfont.a3492406ce2c82f360e9.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-thin-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto-thin-webfont.ttf
// module chunks = styles